module.exports = __webpack_public_path__ + "static/media/Southern_Downs.58d01f2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Southern_Downs.jpg
// module id = 661
// module chunks = 0